import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { Spinner } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./ProviderLanding.css";
import WashtaLogo from "../Home1/Home1Page/washta-logo.png";
import WashtaAppIcon from "../Home1/Home1Page/washta-app-icon.png";
import { CiMail } from "react-icons/ci";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { FaRegFileAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import Nav from "pages/Home1/PhoneResponsiveHeader/Nav";
function OTPPanel({ email }) {
  const [otp, setOTP] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const inputRefs = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

  const handleChange = (index, value) => {
    if (/^\d*$/.test(value)) {
      const next = [...otp];
      next[index] = value.substring(value.length - 1);
      setOTP(next);
      if (value && index < 3) inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    const otpValue = otp.join("");
    if (otpValue.length < 4) {
      setError("Please enter all 4 digits.");
      setLoading(false);
      return;
    }
    try {
      const response = await axios.post(
        "https://production.washta.com/api/otp/verifiction",
        { code: otpValue, role: "seller", email },
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.data.status && response.data.code === 200) {
        if (typeof window !== "undefined") {
          localStorage.setItem("accessToken", response.data.data.accessToken);
        }
        navigate("/become-a-seller/business-details", {
          state: { item: response.data.data },
        });
      } else {
        setError(response.data.message || "Invalid OTP");
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pl-otp-wrap">
      <h3>Enter verification code</h3>
      <p className="pl-fnote">Enter the 4-digit code sent to your registered email.</p>
      <div className="pl-otp-inputs">
        {otp.map((digit, i) => (
          <input
            key={i}
            ref={(el) => (inputRefs.current[i] = el)}
            className="pl-otp-box"
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(i, e.target.value)}
            onKeyDown={(e) => handleKeyDown(i, e)}
          />
        ))}
      </div>
      {error && <p className="pl-emsg-otp">{error}</p>}
      <button 
        type="button"
        className="btn btn-primary apply-submit"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? (
          <Spinner animation="border" size="sm" style={{ color: "#fff", width: "1.4em", height: "1.4em" }} />
        ) : (
          "Verify & continue"
        )}
      </button>
    </div>
  );
}

// ── Main page ─────────────────────────────────────────────────────────────────
export default function ProviderLanding() {
  const applyRef = useRef(null);
  const pageRef = useRef(null);
const location = useLocation();
useEffect(() => {
  if (location.hash === "#apply") {
    setTimeout(() => {
      applyRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }
}, [location]);
  // form state (mirrors BecomeASeller fields exactly)
  const [formData, setFormData] = useState({
    shopName: "",
    username: "",
    password: "",
    email: "",
    fullname: "",
    phone: "",
    role: "seller",
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [otpEmail, setOtpEmail] = useState(null);

  const clearErr = (id) =>
    setFieldErrors((prev) => ({ ...prev, [id]: false }));

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    clearErr(field);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { shopName, username, password, email, fullname, phone } = formData;
    const checks = {
      shopName: shopName.trim().length > 0,
      fullname: fullname.trim().length > 0,
      username: username.trim().length > 0,
      email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim()),
      phone: phone.trim().length > 0,
      password: password.length >= 6,
    };
    const errors = {};
    let ok = true;
    Object.entries(checks).forEach(([k, v]) => {
      errors[k] = !v;
      if (!v) ok = false;
    });
    setFieldErrors(errors);
    if (!ok) return;

    setLoading(true);
    try {
      const { shopName: _shopName, ...payload } = formData;
      const response = await axios.post(
        "https://production.washta.com/api/auth/Signup",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.data.status && response.data.code === 200) {
        if (typeof window !== "undefined") {
          localStorage.setItem("accessToken", response.data.data.accessToken);
        }
        toast.success("OTP has been sent to your email");
        setOtpEmail(formData.email);
      } else {
        toast.error("Sign up failed. Please try again.");
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Sign up failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // reveal animation
  useEffect(() => {
    window.scrollTo(0, 0);
    const root = pageRef.current;
    if (!root) return;
    document.documentElement.classList.add("anim");

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    root.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    root.querySelectorAll(".phero .reveal").forEach((el) => el.classList.add("in"));

    let painted = false;
    const raf1 = requestAnimationFrame(() =>
      requestAnimationFrame(() => { painted = true; })
    );
    const wdog = setTimeout(() => { if (!painted) document.documentElement.classList.remove("anim"); }, 280);

    return () => {
      cancelAnimationFrame(raf1);
      clearTimeout(wdog);
      io.disconnect();
      document.documentElement.classList.remove("anim");
    };
  }, []);

  const scrollToApply = (e) => {
    e?.preventDefault();
    applyRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <title>Washta for Providers — Bring your washes online</title>
        <meta
          name="description"
          content="Apply to join Washta as a car care provider. Get online bookings, cashless payments, and a live sales dashboard."
        />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
        <link
          href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Schibsted+Grotesk:wght@500;600;700;800;900&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <div ref={pageRef}>
        {/* NAV */}
        <header className="nav-version2">
          <div className="wrap nav-inner">
            <a href="/" className="logo" aria-label="Washta">
              <img className="wordmark" src={WashtaLogo} alt="Washta" />
            </a>
            <nav className="nav-links">
              <a href="/#how">How it works</a>
              <a href="/for-providers" className="active">For providers</a>
            </nav>
            <div  className="nav-cta" style={{padding:'7px 26px'}} >
              <a style={{padding:'7px 26px'}} href="#apply" onClick={scrollToApply} className="btn btn-primary btn-sm">Apply to join</a>
            </div>
          </div>
        </header>
         <Nav logo={WashtaLogo} scrollToApply={scrollToApply} />

        {/* PROVIDER HERO */}
        <section className="phero">
          <div className="wrap phero-inner">
            <div>
              <div className="phero-kicker reveal">For car care providers</div>
              <h1 className="reveal d1" style={{fontWeight:700,lineHeight:"0.7em"}}>
                Run washes at the mall?{" "}
                <span className="accent">Bring them online.</span>
              </h1>
              <p className="lead reveal d2">
                Washta gives car care providers online bookings, cashless payments,
                and live sales tracking — you keep running the service, we handle
                the platform.
              </p>
              <div className="phero-actions reveal d3">
                <a href="#apply" onClick={scrollToApply} className="btn btn-primary">Apply to join</a>
                <a href="#benefits" className="btn btn-outline">See what you get</a>
              </div>
            </div>

            {/* Dashboard preview */}
            <div className="dash reveal d2" aria-hidden="true">
              <div className="dash-bar">
                <img className="dash-ic" src={WashtaAppIcon} alt="" />
                <i /><i /><i />
                <span>Washta · Provider dashboard</span>
              </div>
              <div className="dash-row">
                <div className="dash-tile">
                  <div className="lbl">Today's bookings</div>
                  <div className="val">38</div>
                </div>
                <div className="dash-tile">
                  <div className="lbl">Revenue</div>
                  <div className="val green">AED 4,120<span className="up">▲ 12%</span></div>
                </div>
              </div>
              <div className="dash-chart">
                <div className="lbl">Washes this week</div>
                <div className="bars">
                  <i style={{ height: "38%" }} />
                  <i style={{ height: "55%" }} />
                  <i style={{ height: "44%" }} className="hi" />
                  <i style={{ height: "70%" }} />
                  <i style={{ height: "60%" }} className="hi" />
                  <i style={{ height: "88%" }} />
                  <i style={{ height: "74%" }} className="live" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* BENEFITS */}
        <section className="benefits" id="benefits">
          <div className="wrap">
            <div className="sec-head" style={{display:'block'}}>
              <div className="sec-kicker reveal">What you get</div>
              <h2 className="reveal d1" style={{fontWeight:700}}>Keep washing. We'll run the storefront.</h2>
              <p className="sub reveal d2">
                Everything you need to take bookings and get paid — without
                building an app or chasing cash.
              </p>
            </div>
            <div className="bcards">
              <div className="bcard reveal d1">
                <div className="ic">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <rect x="3" y="4" width="18" height="16" rx="3" />
                    <path d="M3 9h18M8 2.5v3M16 2.5v3" />
                    <path d="M8.5 14l2 2 4-4.5" />
                  </svg>
                </div>
                <h3 style={{fontWeight:700}}>Bookings &amp; payments handled</h3>
                <p>Customers book and pay in-app, secured by Stripe. The money lands in your account — no cash, no terminals, no bank fees.</p>
              </div>
              <div className="bcard reveal d2">
                <div className="ic">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <rect x="3" y="3" width="8" height="8" rx="2" />
                    <rect x="13" y="3" width="8" height="5" rx="2" />
                    <rect x="13" y="10" width="8" height="11" rx="2" />
                    <rect x="3" y="13" width="8" height="8" rx="2" />
                  </svg>
                </div>
                <h3 style={{fontWeight:700}}>A dashboard for your locations and crew</h3>
                <p>Track live sales, manage every mall and residential location, and see which crew performs best — all in one place.</p>
              </div>
              <div className="bcard reveal d3">
                <div className="ic">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <circle cx="11" cy="11" r="7" />
                    <path d="M16.5 16.5L21 21" />
                    <path d="M11 8v6M8 11h6" />
                  </svg>
                </div>
                <h3 style={{fontWeight:700}}>Get discovered by customers nearby</h3>
                <p>Customers already parked at your mall find you in the app and book on the spot. No chasing.</p>
              </div>
            </div>
          </div>
        </section>

        {/* APPLY */}
        <section className="apply" id="apply" ref={applyRef}>
          <div className="wrap">
            <div className="apply-card reveal">
              {/* Left purple panel */}
              <div className="apply-left">
                <h2 style={{fontWeight:700}}>Apply to join Washta</h2>
                <p>
                  Tell us about your business and where you operate. We'll review
                  and get you set up — most providers are live within a few days.
                </p>
                <ul className="apply-points">
                  <li>
                    <span className="tick">
                      <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3">
                        <path d="M5 12l5 5 9-10" />
                      </svg>
                    </span>
                    No setup fee to apply
                  </li>
                  <li>
                    <span className="tick">
                      <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3">
                        <path d="M5 12l5 5 9-10" />
                      </svg>
                    </span>
                    Cashless payouts
                  </li>
                  <li>
                    <span className="tick">
                      <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3">
                        <path d="M5 12l5 5 9-10" />
                      </svg>
                    </span>
                    Business insights to grow
                  </li>
                </ul>
              </div>

              {/* Right form panel */}
              <div className="apply-right">
                {otpEmail ? (
                  <OTPPanel email={otpEmail} />
                  // <OTPComponent email={otpEmail} />
                ) : (
                  <form className="applied-form" onSubmit={handleSubmit} noValidate>
                    <h3 style={{fontWeight:700}}>Provider application</h3>
                    <p className="fnote">Takes about 2 minutes. We'll reply by email.</p>

                    <div className="fsection">Business info</div>

                    <div className={`field${fieldErrors.shopName ? " err" : ""}`}>
                      <label>Business name <span className="req">*</span></label>
                      <input
                        type="text"
                        placeholder="e.g. ShinePro Auto Care"
                        value={formData.shopName}
                        onChange={(e) => handleChange("shopName", e.target.value)}
                      />
                      <span className="emsg">Please enter your business name.</span>
                    </div>

                    <div className="fsection mt">Account info</div>

                    <div className={`field${fieldErrors.username ? " err" : ""}`}>
                      <label>Username <span className="req">*</span></label>
                      <input
                        type="text"
                        placeholder="Choose a username"
                        value={formData.username}
                        onChange={(e) => handleChange("username", e.target.value)}
                      />
                      <span className="emsg">Please choose a username.</span>
                    </div>

                    <div className={`field${fieldErrors.fullname ? " err" : ""}`}>
                      <label>Name <span className="req">*</span></label>
                      <input
                        type="text"
                        placeholder="Your full name"
                        value={formData.fullname}
                        onChange={(e) => handleChange("fullname", e.target.value)}
                      />
                      <span className="emsg">Please enter your name.</span>
                    </div>

                    <div className={`field${fieldErrors.email ? " err" : ""}`}>
                      <label>Email <span className="req">*</span></label>
                      <input
                        type="email"
                        placeholder="you@business.com"
                        value={formData.email}
                        onChange={(e) => handleChange("email", e.target.value)}
                      />
                      <span className="emsg">Enter a valid email address.</span>
                    </div>

                    <div className={`field${fieldErrors.phone ? " err" : ""}`}>
                      <label>Phone number <span className="req">*</span></label>
                      <input
                        type="tel"
                        placeholder="+971 …"
                        value={formData.phone}
                        onChange={(e) => handleChange("phone", e.target.value)}
                      />
                      <span className="emsg">Please enter your phone number.</span>
                    </div>

                    <div className={`field${fieldErrors.password ? " err" : ""}`}>
                      <label>Password <span className="req">*</span></label>
                      <input
                        type="password"
                        placeholder="Create a password"
                        value={formData.password}
                        onChange={(e) => handleChange("password", e.target.value)}
                      />
                      <span className="emsg">Password must be at least 6 characters.</span>
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary apply-submit"
                      disabled={loading}
                    >
                      {loading ? (
                        <Spinner animation="border" size="sm" style={{ color: "#fff", width: "1.4em", height: "1.4em" }} />
                      ) : (
                        "Apply to join"
                      )}
                    </button>
                  </form>
                )}
                <p style={{color:'black'}} className="text-center text-sm text-black mt-4 flex gap-2 font-[Manrope]">
                                   Already have an account?{' '}
                                    <Link style={{color:'#6b5fe4'}} to="/sign-in" className="text-[white] font-medium hover:underline font-[Manrope]">
                                     Sign in
                                   </Link>
                                 </p>
              </div>
            </div>
          </div>
        </section>
        <footer>
  <div className="ft-wrap">
    <div className="ft-top">
      <div className="ft-brand">
        <a href="/" className="ft-logo" aria-label="Washta">
          <img src={WashtaLogo} alt="Washta" style={{ height: "22px" }} />
        </a>
        <p className="ft-tagline">Platform only · We connect customers with stationed providers</p>
        <span className="ft-badge">
          <span className="ft-dot" />
          Dubai &amp; Abu Dhabi
        </span>
      </div>

      <div className="ft-right">
        <div className="ft-col">
          <span className="ft-col-title">Contact</span>
          <a href="mailto:info@washta.com">
            <CiMail /> info@washta.com
          </a>
        </div>
        <div className="ft-col">
          <span className="ft-col-title">Legal</span>
          <a href="/PrivacyPolicy"><IoShieldCheckmarkOutline /> Privacy Policy</a>
          <a href="/TermsOfUse"><FaRegFileAlt /> Terms of Use</a>
        </div>
      </div>
    </div>

    <div className="ft-bottom">
      <span className="ft-copy">© 2026 Washta. All rights reserved.</span>
      <span className="ft-powered" style={{display:'flex'}}>
        Powered by <a href="https://bigwals.com" target="_blank" rel="noopener noreferrer" style={{color:'#6b5fe4'}}>Bigwals</a>
      </span>
    </div>
  </div>
</footer>
      </div>
      <ToastContainer />
    </>
  );
}